export type BdrMonthlyExpiryCalendarsActions =
  | BdrMonthlyExpiryDatesRequested
  | BdrMonthlyExpiryDatesReceived
  | BdrMonthlyExpiryDatesFailed
  | BdrMonthlyExpiryDatesTimeout;

export const MONTHLY_EXPIRY_DATES_REQUESTED = 'MONTHLY_EXPIRY_DATES_REQUESTED' as const;
export type BdrMonthlyExpiryDatesRequested = ReturnType<typeof bdrMonthlyExpiryDatesRequested>;
export function bdrMonthlyExpiryDatesRequested(calendarCodes: string[]) {
  return {
    type: MONTHLY_EXPIRY_DATES_REQUESTED,
    calendarCodes,
  };
}

export const MONTHLY_EXPIRY_DATES_RECEIVED = 'MONTHLY_EXPIRY_DATES_RECEIVED' as const;
export type BdrMonthlyExpiryDatesReceived = ReturnType<typeof bdrMonthlyExpiryDatesReceived>;
export function bdrMonthlyExpiryDatesReceived(calendars: IDictionary<string[]>) {
  return {
    type: MONTHLY_EXPIRY_DATES_RECEIVED,
    calendars,
  };
}

export const MONTHLY_EXPIRY_DATES_FAILED = 'MONTHLY_EXPIRY_DATES_FAILED' as const;
export type BdrMonthlyExpiryDatesFailed = ReturnType<typeof bdrMonthlyExpiryDatesFailed>;

export function bdrMonthlyExpiryDatesFailed() {
  return {
    type: MONTHLY_EXPIRY_DATES_FAILED,
  };
}

export const MONTHLY_EXPIRY_DATES_TIMEOUT = 'MONTHLY_EXPIRY_DATES_TIMEOUT' as const;
export type BdrMonthlyExpiryDatesTimeout = ReturnType<typeof bdrMonthlyExpiryDatesTimeout>;

export function bdrMonthlyExpiryDatesTimeout() {
  return {
    type: MONTHLY_EXPIRY_DATES_TIMEOUT,
  };
}
